import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {AnalyticsService, CustomerService, StorageService} from '../../../../_services/index';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../../../_services/index';
import { IonRangeSliderComponent } from 'ng2-ion-range-slider';
import {HttpClient} from '@angular/common/http';
import {Location} from '@angular/common';

@Component({
  selector: 'app-analyticscalllogsdata',
  templateUrl: './analyticscalllogsdata.component.html',
  styleUrls: ['./analyticscalllogsdata.component.css']
})
export class AnalyticscalllogsdataComponent implements OnInit {
  view: any = 'data';
  title = 'Call Logs Analytics';
  @Input('final_score') final_score: any;
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;
  token: any;
  @Input('parentRouteId') parentRouteId: any;
  loan: any;
  selected_analytics = '2';
  nodesandscores: any;
  analytics_result: any;
  sub: any;
  currentUser: any;
  data: any;
  text = 'Call logs Analytcis';
  average_monthly_cost = 0;
  average_calls_per_month = 0;
  nodes_and_scores: any;
  analytics_last_done = '';
  snapshot: any;
  showPicture = false;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  passed_analytics: any;
  failed_analytics: any;
  number_passed: number;
  number_failed: number;
  analytics_score: number;
  sms_value: any;
  guarantor_value: any;
  call_logs_value: any;
  cards_value: any;
  profile_value: any;
  social_value: any;
  accounts_value: any;
  dd_value: any;
  repayment_value: any;
  frequently_called: any;
  monthly_calls: any;
  average_monthly_call_cost: any;
  average_monthly_calls: any;
  incoming_timebelt: any;
  outgoing_timebelt: any;
  highlight: any;
  params: any = JSON.parse(localStorage.getItem('params'));
  call_log_status: any;
  loading: boolean;
  bvn_value: any;
  analytics: any[];
  details: any;
  isChecked = false;
  analyzed_data: any[];
  frequent_incoming_calls: any[];
  frequent_outgoing_calls: any[];
  min_income: any;
  max_income: any;
  customer_name: any;
  constructor(public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public router: Router,
              private  http: HttpClient,
              private analyticsService: AnalyticsService,
              private _location: Location
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
    //this.call_logs_value = this.params.calllogs;
  }
  ngOnInit() {
    this.getAnalyticsData();
  }
  doingDisbursement(event) {

  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  getAnalyticsData() {
    this.loading = true;
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.loansService.getCalllogsAnalyticsData(this.currentUser.token, this.parentRouteId)
        .subscribe(data => {
          this.loading = false;
          this.loan = data.loan;
          this.analytics = data.loan.analytics_summary.description.calllogs_;
          this.customer_name = data.loan.customer.legal_name;
          this.final_score = data.loan.analytics_summary.final_analytics_score;
          this.failed_analytics = data.loan.analytics_summary.description.calllogs.failed;
          this.number_passed = data.loan.analytics_summary.counts.calllogs_passed;
          this.number_failed = data.loan.analytics_summary.counts.calllogs_failed;
          this.analytics_score = data.loan.analytics_summary.calllogs;
          this.frequently_called = data.loan.analytics_summary.output.calllogs.response.data.frequent_all_calls;
          this.frequent_incoming_calls = data.loan.analytics_summary.output.calllogs.response.data.frequent_incoming_calls;
          this.frequent_outgoing_calls = data.loan.analytics_summary.output.calllogs.response.data.frequent_outgoing_calls;
          this.monthly_calls = data.loan.analytics_summary.output.calllogs.response.data.calls;
          this.average_monthly_call_cost = data.loan.analytics_summary.output.calllogs.response.data.average.average_monthly_call_cost;
          this.min_income =  data.loan.analytics_summary.output.calllogs.response.data.average.projectedExpenseProfileMin;
          this.max_income =  data.loan.analytics_summary.output.calllogs.response.data.average.projectedExpenseProfileMax;
          this.average_monthly_calls = data.loan.analytics_summary.output.calllogs.response.data.average.average_monthly_calls;
          this.outgoing_timebelt = data.loan.analytics_summary.output.calllogs.response.data.average.outgoing_timebelt;
          this.incoming_timebelt = data.loan.analytics_summary.output.calllogs.response.data.average.incoming_timebelt;
          this.highlight = data.loan.analytics_summary.output.calllogs.response.data.highlights;
          this.call_log_status = data.loan.analytics_summary.status.calllogs;
          this.dataService.onRequestLoadingEndFromBackend.emit({loan: data.loan});
          this.analyzed_data = this.analytics.filter(analyzed => {
            return analyzed.status === 'failed';
          });
        });
    });



  }

  dataView() {
    this.view = 'data';
  }

  analyticsView() {
    this.view = 'analytics';
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId });
  }
  saveAnalytics(event) {
    this.loansService.saveSMSAnalysisData(this.currentUser.token, this.parentRouteId, this.nodes_and_scores, this.data)
      .subscribe(data => {
        this.data = data.result;
        this.details = data.result;
        this.nodes_and_scores = data.nodes_and_scores;
        this.analytics_last_done = data.analytics_last_done;
        this.loan = data.loan;
      });
  }
  modifyAnalytics() {
    this.dataService.onEditApplicationsModal.emit({ section: 'specific_analytics', request_id: this.parentRouteId, nodes_and_scores: this.nodes_and_scores, selected_analytics: '2', analytics_last_done: this.analytics_last_done, isedit: '1' });
  }
  getAnalytics() {
    return new Promise((resolve, reject) => {
      return this.http
        .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
          request_id: '13126'
        })
        .toPromise()
        .then(res => {
          //console.log(res);
          this.lender_id = res.lender_id;
          this.borrower_id = res.borrower_id;
          this.principal = res.principal;
          this.maturity_date = res.maturity_date;
          this.account_card_id = res.account_card_id;
          this.loan_request_id = res.loan_request_id;
          this.card_id = res.card_id;
          resolve();
        })
        .then(() => this.getFullAnalytics())
        .catch(err => {
          //console.log(err);
          // reject();
        });
    });
  }
  getFullAnalytics() {
    //console.log(this.lender_id);
    return this.analyticsService
      .getFullAnalytics(
        this.lender_id,
        this.borrower_id,
        this.principal,
        this.maturity_date,
        this.account_card_id,
        this.loan_request_id,
        this.card_id,
        this.sms_value,
        this.call_logs_value,
        this.profile_value,
        this.guarantor_value,
        this.cards_value,
        this.accounts_value,
        this.dd_value,
        this.repayment_value,
        this.social_value,
        {}
      )
      .subscribe(data => {
        this.passed_analytics = data.description.calllogs.passed;
        this.failed_analytics = data.description.calllogs.failed;
        this.number_passed = this.passed_analytics.length;
        this.number_failed = this.failed_analytics.length;
        this.analytics_score = data.calllogs;
        this.frequently_called = data.output.calllogs.response.data.frequent_all_calls;
        this.monthly_calls = data.output.calllogs.response.data.calls;
        this.average_monthly_call_cost = data.output.calllogs.response.data.average.average_monthly_call_cost;
        this.average_monthly_calls = data.output.calllogs.response.data.average.average_monthly_calls;
        this.outgoing_timebelt = data.output.calllogs.response.data.average.outgoing_timebelt;
        this.incoming_timebelt = data.output.calllogs.response.data.average.incoming_timebelt;
        this.highlight = data.output.calllogs.response.data.highlights;
        this.call_log_status =data.status.calllogs;
      });
  }
  // saveSMSAnalyticsResult() {
  //   this.saveAnalytics.emit();
  // }
  // modifyAnalyticsResult() {
  //   this.modifyAnalytics.emit();
  // }
  goBack() {
    this._location.back();
  }
  checked() {
    this.isChecked = !this.isChecked;
  }
}
